// extracted by mini-css-extract-plugin
export var column = "Columns-module--column--HVvny";
export var container = "Columns-module--container--orDl-";
export var header = "Columns-module--header--kUGMD";